var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TextField, makeStyles } from "@material-ui/core";
import clsx from "clsx";
export default React.forwardRef((_a, ref) => {
    var { size, InputProps = {}, InputLabelProps = {}, FormHelperTextProps = {}, className, variant = "outlined", focused = false } = _a, other = __rest(_a, ["size", "InputProps", "InputLabelProps", "FormHelperTextProps", "className", "variant", "focused"]);
    const classes = useStyles({ focused });
    return (React.createElement(TextField, Object.assign({}, other, { focused: focused, classes: {
            root: clsx(className, classes.root, InputProps.readOnly && classes.readonly),
        }, ref: ref, InputLabelProps: Object.assign({ variant: "standard", shrink: true, classes: {
                root: classes.label,
                asterisk: classes.asterisk,
                error: classes.error,
            } }, InputLabelProps), FormHelperTextProps: Object.assign({ classes: {
                root: classes.helperText,
                disabled: classes.helperTextDisabled,
                error: classes.helperTextError,
            } }, FormHelperTextProps), InputProps: Object.assign({ classes: {
                root: clsx(classes.inputRoot, size === "small" && classes.small),
                error: classes.error,
                focused: classes.inputFocused,
                disabled: classes.disabled,
                input: classes.input,
                multiline: classes.inputBaseMultiline,
            } }, InputProps), variant: variant })));
});
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& .MuiInputAdornment-root": {
            zIndex: 1,
        },
    },
    label: Object.assign(Object.assign({ position: "static", marginBottom: "8px", transform: "none" }, theme.typography.h5), { color: `${theme.palette.text.tertiary} !important`, whiteSpace: "nowrap" }),
    helperText: {
        marginTop: theme.spacing(1),
        color: "#627084",
        marginLeft: 0,
        marginRight: 0,
    },
    helperTextDisabled: {
        color: "#627084",
    },
    helperTextError: {
        color: theme.palette.text.error,
    },
    inputBaseMultiline: {
        padding: 0,
    },
    input: Object.assign(Object.assign({ padding: "11.7px 8px", zIndex: 1, outline: "none", borderRadius: 4, "&:-webkit-autofill": {
            transitionDelay: "9999s",
            transitionProperty: "background-color, color",
        } }, theme.typography.listItemText), { color: theme.palette.text.primary }),
    readonly: {
        "& $inputRoot": ({ focused }) => !focused
            ? {
                cursor: "default",
            }
            : {},
        "& $input": ({ focused }) => !focused
            ? {
                cursor: "default",
            }
            : {},
        "& $inputFocused": ({ focused }) => !focused
            ? {
                "&:not($error) > fieldset": {
                    borderWidth: "1px !important",
                    borderColor: `${theme.palette.border.textField} !important`,
                },
                "&:not($error):hover > fieldset": {
                    backgroundColor: `${theme.palette.textField.hover} !important`,
                },
                "&:not($error):not(:hover) > fieldset": {
                    backgroundColor: `${theme.palette.textField.inactive} !important`,
                },
            }
            : {},
    },
    inputRoot: Object.assign(Object.assign({}, theme.typography.listItemText), { color: theme.palette.text.primary, "&.MuiInput-underline:after": {
            borderBottom: "none !important",
        }, "&.MuiInput-underline:before": {
            borderBottom: "none !important",
        }, "& fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.border.textField,
        }, "&:not($inputFocused):not($error):not($disabled):hover > fieldset": {
            backgroundColor: theme.palette.textField.hover,
            borderColor: theme.palette.border.textField,
        }, "&:not($inputFocused):not($disabled) > fieldset": {
            backgroundColor: theme.palette.textField.inactive,
        }, "& > fieldset": {
            top: 0,
        }, "& > fieldset > legend": {
            display: "none",
        }, "&.MuiInputBase-adornedStart": {
            paddingLeft: 4,
        }, "&.MuiInputBase-adornedEnd": {
            marginRight: 0,
            marginLeft: 0,
            paddingRight: 8,
            "&$small $input": {
                padding: "7.7px 0 7.7px 7.7px",
            },
            "&:not($small) $input": {
                padding: "11.7px 0 11.7px 8px",
            },
            "& button": {
                padding: "0",
            },
            "& svg": {
                zIndex: 1,
            },
        }, "& .MuiInputAdornment-positionEnd": {
            marginLeft: 0,
        } }),
    small: {
        "& > input": {
            padding: "7.7px",
        },
        "& > fieldset": {
            top: 0,
        },
    },
    error: {
        "& > fieldset": {
            borderWidth: "2px",
            borderColor: `${theme.palette.border.textFieldError} !important`,
        },
    },
    disabled: {
        color: theme.palette.text.disable,
        "& > fieldset": {
            border: "none",
            backgroundColor: theme.palette.textField.disabled,
        },
    },
    inputFocused: {
        "&:not($error) > fieldset": {
            background: theme.palette.textField.focus,
            borderColor: `${theme.palette.border.focus}`,
        },
    },
    asterisk: { color: theme.palette.text.error },
}));
//# sourceMappingURL=FTLTextField.js.map